import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {getExportLabel} from "../../../services/api/apiBarcode"

class ExportTracking extends Component {
    _exportTracking = async () => {
        try {
            const {filter} = this.props
            let tagsExport = []
            if(filter.tags)  tagsExport.push(...filter.tags)
            if(filter.list_tags) tagsExport.push(...filter.list_tags)

            const {list_tags, tags, ...rest} = filter

            const cloneFilterExp = Object.assign({}, rest)

            delete cloneFilterExp['created']
            delete cloneFilterExp['generated']
            delete cloneFilterExp['barcodeNumber']

            if(tagsExport.length > 0){
                cloneFilterExp['tags[]'] = tagsExport
            }

            if (filter.created.hasOwnProperty('from')) {
                cloneFilterExp['created[from]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilterExp['created[to]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilterExp['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilterExp['generated[to]'] = filter.generated.to
            }

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilterExp['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilterExp['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilterExp['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilterExp['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilterExp['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilterExp['generate_label_config.delay_days']
                }
            }

            if(filter.is_fba) {
                if(filter.is_fba === 'TikTok'){
                    cloneFilterExp.is_tiktok = 'y'
                    delete cloneFilterExp.is_fba
                }else if(filter.is_fba === 'n'){
                    cloneFilterExp.is_tiktok = 'n'
                }
            }

            window.location.href = getExportLabel({...cloneFilterExp})
        } catch (e) {
            alert(e.toString())
        }
    }

    render() {
        return (
            <Button className="btn btn-warning btn-labeled btn-labeled-left ml-1" onClick={this._exportTracking}>
                <b><i className="icon-barcode2"/></b>
                Export Tracking
            </Button>
        )
    }
}

ExportTracking.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportTracking
